<template>
    <button class="bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white whitespace-nowrap tracking-wider font-medium px-3 py-1 rounded-sm" >
        <slot></slot>
    </button>
</template>

<script setup></script>